<template>
    <BotFlow v-if="botid" :botid="botid" :config="{review: true}" data-testid="financialclose-automation-riskmanagement-bot-view"></BotFlow>
  </template>
  
  <script>
  import BotFlow from './components/BotFlowriskmanagement.vue';
  export default {
    name: 'bots_view',
    // props: ['props'],
    data: function () {
      return {
        botid: "",
        project: "",
      }
    },
    components: {
      BotFlow
    },
    created() {
      this.refreshData();
    },
    activated() {
      this.refreshData();
    },
    methods: {
      refreshData() {
        this.botid = this.$route.params.botID;
      },
    },
    watch: {
    }
  }
  </script>
  